import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDVHHfl9dHr0UYYuPJIVbweZ3x2KtePmOo",
  authDomain: "smart-agri-a3017.firebaseapp.com",
  projectId: "smart-agri-a3017",
  storageBucket: "smart-agri-a3017.firebasestorage.app",
  messagingSenderId: "933443549836",
  appId: "1:933443549836:web:b096417b38e3576910d9a9"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
    